import Chart from 'react-apexcharts';
import styled from 'styled-components';

export { ChartHeader, StyledChart };

const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--size-16);
`;

const StyledChart = styled(Chart)``;

export const ChartWrapper = styled.div``;
